(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a.about-back-to-top');

    if (
      !link ||
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    event.preventDefault();

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'instant'
      : 'smooth';

    document.querySelector('.page-wrapper')?.scrollTo({ top: 0, behavior });
    window.scrollTo({ top: 0, behavior });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-back"] && !Shopify.designMode) return;
  try {
    (() => {
  const link = document.querySelector('[data-page-back]');
  if (!link) return;

  const label = link.querySelector('[data-page-back-label]');

  function safeUrl(value) {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      if (/\/(?:checkouts?|account|customer_authentication|challenge|admin)(?:\/|$)/i.test(url.pathname)) return null;
      if (/\/cart\/.+/i.test(url.pathname)) return null;
      return url;
    } catch {
      return null;
    }
  }

  function pageKey(url) {
    const key = new URL(url.href);
    key.hash = '';
    key.searchParams.delete('preview_theme_id');
    if (key.pathname.includes('/products/')) {
      key.pathname = key.pathname.replace(/\/collections\/[^/]+(?=\/products\/)/, '');
      key.searchParams.delete('variant');
    }
    key.searchParams.sort();
    return key.pathname + key.search;
  }

  function destination() {
    const current = safeUrl(window.location.href);
    const currentKey = current ? pageKey(current) : '';
    const navigation = window.navigation;
    const canInspect = typeof navigation?.entries === 'function' && navigation.currentEntry;

    if (canInspect) {
      const entries = navigation.entries();
      const index = entries.findIndex((entry) => entry.key === navigation.currentEntry.key);
      for (let previous = index - 1; previous >= 0; previous -= 1) {
        const entry = entries[previous];
        const url = safeUrl(entry.url);
        if (!url) break;
        if (pageKey(url) !== currentKey) return { url: url.href, key: entry.key, label: link.dataset.backLabel };
      }
    }

    const referrer = safeUrl(document.referrer);
    if (referrer && pageKey(referrer) !== currentKey) {
      return {
        url: referrer.href,
        useHistory: !canInspect && window.history.length > 1,
        label: link.dataset.backLabel,
      };
    }

    const shop = safeUrl(link.dataset.shopUrl);
    const home = safeUrl(link.dataset.homeUrl);
    const onShop = current && shop && current.pathname === shop.pathname;
    return {
      url: (onShop ? home : shop).href,
      label: onShop ? link.dataset.homeLabel : link.dataset.shopLabel,
    };
  }

  function updateLink() {
    const target = destination();
    link.href = target.url;
    label.textContent = target.label;
    return target;
  }

  link.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = updateLink();
    if (target.key && typeof window.navigation?.traverseTo === 'function') {
      event.preventDefault();
      try {
        const result = window.navigation.traverseTo(target.key);
        Promise.all([result.committed, result.finished]).catch((error) => {
          if (error?.name !== 'AbortError') window.location.assign(target.url);
        });
      } catch {
        window.location.assign(target.url);
      }
    } else if (target.useHistory) {
      event.preventDefault();
      window.history.back();
    }
  });

  updateLink();
  window.addEventListener('pageshow', updateLink);
  window.addEventListener('popstate', updateLink);
  window.navigation?.addEventListener('currententrychange', updateLink);
})();
  } catch(e) { console.error(e); }
})();

})();
